import React from "react";

const PageNotFound = () => {
	return <h1>This page dosent exist!</h1>;
};

export default PageNotFound;
